import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MeteredgptChatBotComponent } from './metered-chat-bot/meteredgpt-chat-bot.component';
import { MsalGuard } from '@azure/msal-angular';

const guards: any[] = [MsalGuard];

const routes: Routes = [
  { path: '', component: MeteredgptChatBotComponent, canActivate: guards },
  { path: '', redirectTo: '/', pathMatch: 'full' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule],
  providers: [MsalGuard]
})

export class AppRoutingModule { }
